import Http from '../http'

export const getTheme = () => Http.get('/preferences/theme', { headers: { Authorization: localStorage.token } })
export const show = () => Http.get('/preferences', { headers: { Authorization: localStorage.token } })
export const update = (data) => Http.patch('/preferences', data, { headers: { Authorization: localStorage.token } })
